import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "sonner";
import { loadBrandLogoDataUrl } from "./lib/brandAssets";

import Landing from "./pages/Landing";
import MerchantList from "./pages/MerchantList";
import MerchantDetail from "./pages/MerchantDetail";
import EventsPage from "./pages/EventsPage";
import Membership from "./pages/Membership";
import PartnerWithUs from "./pages/PartnerWithUs";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MembershipPayment from "./pages/MembershipPayment";
import MemberQRFallback from "./pages/MemberQRFallback";
import HydroPayment from "./pages/HydroPayment";
import HydroApply from "./pages/HydroApply";
import ShopPage from "./pages/ShopPage";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";

import MemberDashboard from "./pages/MemberDashboard";
import Scanner from "./pages/Scanner";
import MerchantDashboard from "./pages/MerchantDashboard";
import AdminDashboard from "./pages/AdminDashboard";

import ProtectedRoute from "./components/brand/ProtectedRoute";
import PWAInstallPrompt from "./components/brand/PWAInstallPrompt";
import ErrorBoundary from "./components/brand/ErrorBoundary";
import MessengerButton from "./components/brand/MessengerButton";

function App() {
  useEffect(() => {
    loadBrandLogoDataUrl();
    // Hide the "Made with Emergent" badge for production branding
    const badge = document.getElementById("emergent-badge");
    if (badge) badge.style.display = "none";
  }, []);
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0d0d0d", color: "#fff", border: "1px solid rgba(212,175,55,0.3)" } }} />
          <PWAInstallPrompt />
          <MessengerButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/partners" element={<MerchantList />} />
            <Route path="/partners/:id" element={<MerchantDetail />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/partner-with-us" element={<PartnerWithUs />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/shop/:id" element={<ProductDetail />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/q/m/:token" element={<MemberQRFallback />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/membership/payment" element={<ProtectedRoute roles={["member"]}><MembershipPayment /></ProtectedRoute>} />
            <Route path="/hydro/apply" element={<HydroApply />} />
            <Route path="/hydro/payment" element={<HydroPayment />} />
            <Route path="/hydro/payment/:appId" element={<HydroPayment />} />

            <Route path="/me/*" element={<ProtectedRoute roles={["member"]}><MemberDashboard /></ProtectedRoute>} />
            <Route path="/scanner/*" element={<ProtectedRoute roles={["cashier", "merchant_owner", "super_admin"]}><Scanner /></ProtectedRoute>} />
            <Route path="/merchant/*" element={<ProtectedRoute roles={["merchant_owner", "cashier"]}><MerchantDashboard /></ProtectedRoute>} />
            <Route path="/admin/*" element={<ProtectedRoute roles={["super_admin"]}><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
